import React from 'react';
import LegalPage from './home/LegalPage';

const TermsAndConditions = () => <LegalPage page="terms" path="/algemene-voorwaarden" testId="terms-page" />;

export default TermsAndConditions;
